import Shared from '../../../../asset/shared.png'
import React from 'react'
import Edit from '../../../../asset/bookmark.png'
import Delete from '../../../../asset/bin.png'
import Close from '../../../../asset/close.png'
import { store } from '../../../../lib/store'
import LayerNodeDescription from '../../../main-ui/left-toolbar/layers/layer/tooltip'
import { createRoot } from 'react-dom/client';
import { dateConvertion } from '../../common/commonfunctions'

export function createInfoContent(data, callback, dispatchFunction) {
  let { mapReference, mapObj, mapPhotoObj, friendData, photo, infoWindow, location } = data;
  let { editFunction, deleteFunction, closeFunction, updateInfoWindow, editHuntWind } = callback
  let newInfoWindow

  const reduxState = store.getState();
  const { userPreferences } = reduxState;

  const infoWindowContent = (value, handleEdit) => {
    let latitude = parseFloat(friendData && friendData.lat).toFixed(5)
    let longitude = parseFloat(friendData && friendData.lng).toFixed(5)

    const container = document.createElement('div');
    container.style = `padding: 10px; height: 110px; width:150px; background-color: black; border-radius:10px`;
    const formattedDate = dateConvertion(friendData.timeStamp)

    // Create the content HTML
    container.innerHTML = `
     <div class="info-window-header-container">      
        <div id="my-react-component-container" style="width: 90%; margin-top:10px"></div>
        <div class="info-window-closeicon">
          <a id="close">
              <img style="width: 15px; object-fit: cover; float: right;  margin-top: -10px; " src=${Close}
                  alt="Edit"></img>
          </a>
        </div> 
      </div>      
      
      <div style="width: 100%; display: flex;justify-content: center;margin-top:10px">
          <div style="width: 98%;">
                   <h6 class="friend-loc-info-box-head">Lattitude: <span class="friend-loc-info-box-span">${latitude}</span></h6>
              <h6 class="friend-loc-info-box-head">Longitude: <span class="friend-loc-info-box-span">${longitude}</span></h6>    
              <h6 class="friend-loc-info-box-head">Updated: <span class="friend-loc-info-box-span">${formattedDate}</span></h6>                                                                                                                               
          </div>                                
      </div>
      </div>                                                  
      <div class="triangle-container">
          <div class="triangle-shape" style="margin-bottom: 3px;"></div>
      </div>  `

    const style = document.createElement('style');
    style.innerHTML = `
          .triangle-shape {
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-bottom: 30px solid #000000;
            transform: rotate(225deg);
          }
            
          .triangle-container {
            justify-content: center;
            align-items: center;
            position: absolute;
            left: -10px;
            bottom: -15px;
          }
    
          .gm-style .gm-style-iw-c {
            padding: 0px !important;
            left: 95px !important;
            top: -36px !important;
          }
          `;



    const reactComponentContainer = container.querySelector('#my-react-component-container');

    if (reactComponentContainer) {
      const root = createRoot(reactComponentContainer); // For React 18 and later
      root.render(<LayerNodeDescription value={friendData.fullName} parent={true} />);
    }

    document.head.appendChild(style);

    container.querySelector('#close').addEventListener('click', closeFunctionCb);

    // // Append the container to the body
    document.body.appendChild(container);
    return container;
  };

  if (infoWindow && infoWindow.infoWindowFunction
  ) {
    infoWindow.infoWindowFunction.close()
  }

  newInfoWindow = new google.maps.InfoWindow({
    content: infoWindowContent(friendData),
    disableAutoPan: true, // Prevents the info window from panning the map to fully display itself
    pixelOffset: new google.maps.Size(0, -10), // Adjusts the position of the info window
    maxWidth: 544, // Maximum width of the info window
  });

  if (newInfoWindow) {
    dispatchFunction && dispatchFunction(newInfoWindow)
  }

  function closeFunctionCb() {
    closeFunction(newInfoWindow)
  }

  newInfoWindow.setPosition(location); // Ensure `photo.location` is a valid LatLng object

  newInfoWindow.open(mapReference, mapObj ? mapObj : mapPhotoObj);
  newInfoWindow && updateInfoWindow(newInfoWindow)
}